module.exports = __webpack_public_path__ + "img/mock-bg.4e387e.png";